import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PriorityTypesService {

  constructor(
    private http: HttpClient,
    private device: Device,
    private authentication: AuthenticationService
  ) { }

  getPriorityTypes() {
    const url = environment.PRESSROOM_API_URL + 'priorityTypes'

    return this.http.get(url).pipe(
      map((data: any) => data.priority_types),
      switchMap((priorityTypes) => {
        return of(priorityTypes);
      }),
      catchError(err => {
        return err.error;
      })
    );
  }

  allowPriorityTypes(userID: string) {
    var platform = this.device.platform || "web";
    return this.authentication.generateDeviceId(platform, userID).then(id => {
      return this.authentication.getDevice(id, userID);
    });
  }
}
